import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import useStyles from '../useStyles';
import { Popper } from '@mui/material';
import moment from 'moment';

import ScheduleIcon from '@mui/icons-material/Schedule';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

function ChatItem({ message }) {
  const [isOpen, setIsOpen] = useState(false);
  const anchor = useRef(null);

  const classes = useStyles();

  return (
    <div
      className={`${classes.chatItemContainer} ${message.status === 'received' ? classes.alignRight : ''}`}
    >
      <div
        className={`${classes.chatItem} ${message.status === 'received' ? classes.fromCandidate : ''}`}
      >
        {message.body}
      </div>
      <div
        ref={anchor}
        className={classes.status}
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      >
        {message.status === 'scheduled' && <ScheduleIcon fontSize="small" color="disabled" />}
        {message.status === 'bounced' && <ErrorOutlineIcon fontSize="small" color="error" />}
      </div>
      <Popper
        className={classes.popper}
        anchorEl={anchor.current}
        open={isOpen}
        placement="top-center"
      >
        {message.status === 'scheduled' ? (
          <div>{`Scheduled for ${moment(message.scheduled_time).format('lll')}`}</div>
        ) : (
          <div>{`Message bounced`}</div>
        )}
      </Popper>
    </div>
  );
}

ChatItem.propTypes = {
  message: PropTypes.object.isRequired
};

export default ChatItem;
